import type { GrantablePermission } from "@pokifolio/contracts";

/** Plain-language names for permissions an admin can grant to an employee. */
export const PERMISSION_LABELS: Record<GrantablePermission, string> = {
  "search.run": "Search eBay and the web",
  "research.update_any": "Edit any research record",
  "catalog.manage": "Add cards to the catalog",
  "portfolio.view_costs": "See purchase costs",
  "portfolio.view_values": "See card values",
  "portfolio.view_analytics": "See portfolio reports",
};
